// Services
import { SvgService } from '@services/svg.service';
import { WidgetsService } from '@services/widgets.service';
import { ThemeService } from '@services/theme/theme.service';
import { I18nService } from '@services/i18n.service';

// Types
import { TArrowFunction } from '../types/global.types';

export function initializeApplication(
  svgService: SvgService,
  themeService: ThemeService,
  i18nService: I18nService,
): TArrowFunction<Promise<boolean>> {
  return () =>
    new Promise((resolve, _) => {
      // Set the default language for the application
      i18nService.initLanguage();

      // Set the default theme for the application
      themeService.setDefaultTheme();

      // Register SVG icons
      svgService.registryIcons();

      // Resolve the promise indicating successful initialization
      resolve(true);
    });
}

export function initializeWidget(widgetService: WidgetsService) {
  return () =>
    widgetService.firstLoadWidget$.next(window.location.pathname.includes('engineers-widget'));
}
